module.exports = __webpack_public_path__ + "img/action2.4e458d73.jpg";